module.exports = __webpack_public_path__ + "static/media/logoorange.a079f841.png";